import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    query: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      console.log('Sending request to:', `${process.env.REACT_APP_API_URL}/api/send-email`);
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData),
        credentials: 'include'
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Server response:', data);

      if (data.success) {
        setStatus('success');
        setFormData({ name: '', phone: '', query: '' });
      } else {
        throw new Error(data.message || 'Server error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
      setAlertMessage(error.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <h2 className="text-center mb-4">Contact Us</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Query</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="query"
                value={formData.query}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button 
              type="submit" 
              className="w-100"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Submit'}
            </Button>

            {status === 'success' && (
              <div className="alert alert-success mt-3">
                Thank you for contacting us! We will get back to you soon.
              </div>
            )}
            {status === 'error' && (
              <div className="alert alert-danger mt-3">
                {alertMessage}
              </div>
            )}
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
